module.exports = __webpack_public_path__ + "img/arrow_right.cff3da9f.svg";